<template>
  <div v-if="subsection">
    <div v-if="!isEditMode">
      <h5 v-if="subsection.title" v-html="subsection.title"></h5>
      <div v-if="subsection.text" v-html="editedText"></div>
      <div class="mb-2">
        <div class="mb-2">
          <div>Введите формулу</div>
          <b-input type="text" v-model="formula" autocomplete="off"></b-input>
        </div>
        <div>Введённая формула</div>
        <b-alert show  v-if="formula && formula.length" >
          <katex-element :expression="formula"/>
        </b-alert>
        <b-alert v-else show>Вы ничего не ввели</b-alert>
      </div>
      <div class="text-center my-3" v-if="!isTestReviewMode">
        <b-button variant="primary" @click="sendAnswers">
          {{isTriedToAnswer ? 'Ответить ещё раз' : 'Ответить'}}
        </b-button>
      </div>
    </div>
    <div v-else>
      <h4>Заголовок</h4>
      <b-form-input
        :value="subsection.title"
        placeholder="Введите название"
        @input="$_subsectionMixin_onTitleChange"></b-form-input>
      <h4 class="mt-3">Текст</h4>
      <wysiwyg-text-editor dataType="subSectionText" />
      <div class="mb-2">
        <div>Ответ</div>
        <b-form-input
          :value="(subsection.qstruct) ? subsection.qstruct.answer : ''"
          placeholder="Введите формулу"
          @input="onAnswersChange" autocomplete="off"></b-form-input>
      </div>
      <div>Введённая формула</div>
      <b-alert show  v-if="answer && answer.length" >
        <katex-element :expression="answer"/>
      </b-alert>
      <b-alert v-else show>Вы ничего не ввели</b-alert>
    </div>
    <div>
      <hr noshade>
      <h5>Описание синтаксиса</h5>
      <div>
        <b-alert show>Для просмотра перейдите по <a href="https://en.wikibooks.org/wiki/LaTeX/Mathematics" target="_blank"> ссылке</a></b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

import ContentMixin from '@/components/helpers/mixins/content-mixin'
import SubsectionMixin from '@/components/helpers/mixins/subsection-mixin'

export default {
  name: 'FormulaTestSubSection',
  components: {
    WysiwygTextEditor
  },
  mixins: [ContentMixin, SubsectionMixin],
  data() {
    return {
      isTriedToAnswer: false,
      formula: '',
      answer: '',
      editedText: ''
    }
  },
  created() {
    this.updateSubsection()
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  updated() {
    this.editedText = this.$_contentMixin_editCaptions(this.subsection.text)
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      subsection: 'education/getSubsection',
      isTestingMode: 'test/isTestingMode',
      test: 'test/getTest',
      progress: 'test/getProgress',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      solvedByStudent: 'educationStudentsManagement/getSolvedByStudent'
    })
  },
  watch: {
    subsection() {
      this.isTriedToAnswer = false
      this.updateSubsection()
    }
  },
  methods: {
    ...mapMutations({
      setTestingMode: 'test/setTestingMode'
    }),
    ...mapActions({
      sendAnswer: 'education/sendAnswer',
      sendTestAnswer: 'test/sendTestAnswer'
    }),
    updateSubsection() {
      let answer = ''
      this.answer = (this.subsection.qstruct) ? this.subsection.qstruct.answer : ''
      if (this.isTestingMode) {
        answer = this.$_subsectionMixin_getAnswerCookies(this.test.id)
      } else if (this.isTestReviewMode) {
        answer = this.$_subsectionMixin_getAnswerFromData(this.test, this.solvedByStudent)
      }
      this.formula = answer || ''
    },
    sendAnswers() {
      if (!this.isTestingMode) {
        this.sendAnswer({
          courseId: this.$route.params.courseBookId,
          subsectionId: this.$route.params.subsectionId,
          answer: this.formula,
          type: 'test'
        })
        this.isTriedToAnswer = true
      } else {
        this.$cookies.set(`test_${this.$route.params.sectionId}_${this.$route.params.subsectionId}_formula`, this.formula)
        const questions = this.$cookies.keys().filter((k) => k.includes(`test_${this.test.id}`))
        this.$_subsectionMixin_updateSolved(questions)
      }
    },
    onAnswersChange(event) {
      this.answer = event
      this.$_subsectionMixin_onAnswerChange(event)
    }
  }
}
</script>

<style scoped>

</style>
